import App from 'app/app.js';
import 'app/store/SubjectStore.js';
import 'app/store/ShoppingCartStore.js';
import { isFraudDetected, isUserProfileUrl } from '@app/interceptor/interceptor-logic';

function UserProfileInterceptor($injector) {
  return {
    response: function (response) {
      if (!isUserProfileUrl(response.config.url)) {
        return response;
      }
      let data = response.data.data;
      if (isFraudDetected(data)) {
        let SubjectStore = $injector.get('SubjectStore');
        let ShoppingCartStore = $injector.get('ShoppingCartStore');
        SubjectStore.clearAll();
        ShoppingCartStore.clearAll();
      }
      return response;
    }
  };
}

App.factory('UserProfileInterceptor', ['$injector', UserProfileInterceptor]);
App.config([
  '$httpProvider',
  function ($httpProvider) {
    $httpProvider.interceptors.push('UserProfileInterceptor');
  }
]);
